var map = {
	"./author/author-1.jpg": 3040,
	"./blog-big-1.jpg": 3675,
	"./blog-big-2.jpg": 6923,
	"./blog-big-3.jpg": 3067,
	"./blog-big-4.jpg": 668,
	"./blog-big-5.jpg": 1759,
	"./comment/comments-1.png": 1557,
	"./comment/comments-rep-1.png": 5042,
	"./comment/comments-rep-2.png": 4060,
	"./quote-icon.png": 4114,
	"./rc/rc-1.jpg": 9419,
	"./rc/rc-2.jpg": 9489,
	"./rc/rc-3.jpg": 6869,
	"./sm1.jpg": 5928,
	"./sm2.jpg": 6154,
	"./sm3.jpg": 2143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9985;